import LeadCaptureForm, {
  LeadCaptureFormProps,
  leadCaptureFormSchema,
  LeadCaptureFormValues,
} from './LeadCaptureForm'

export default LeadCaptureForm
export { leadCaptureFormSchema }
export type { LeadCaptureFormValues, LeadCaptureFormProps }
